import React, { lazy } from "react";
import { useRoutes } from "react-router-dom";
// Layouts
import MainLayout from "layout/MainLayout";

const Home = lazy(() => import("pages/index"))

// ==============================|| ROUTINGs ||============================== //

export default function Routes() {
  return useRoutes([
    {
      path: "/",
      element: (
        <MainLayout>
          <Home />
        </MainLayout>
      ),
    },
  ]);
}
